import { Media } from "./Media";
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var ComponentWrapper = function ComponentWrapper(_ref) {
  var style = _ref.style,
      className = _ref.className,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'pc' : _ref$mode,
      children = _ref.children;

  var calcContentByMode = function calcContentByMode() {
    switch (mode) {
      case 'pc':
        return /*#__PURE__*/_jsx(Media, {
          greaterThan: "md",
          className: className,
          style: style,
          children: children
        });

      case 'pad':
        return /*#__PURE__*/_jsx(Media, {
          between: ['md', 'lg'],
          className: className,
          style: style,
          children: children
        });

      case 'mobile':
        return /*#__PURE__*/_jsx(Media, {
          lessThan: "md",
          className: className,
          style: style,
          children: children
        });

      case 'notPC':
        return /*#__PURE__*/_jsx(Media, {
          lessThan: "lg",
          className: className,
          style: style,
          children: children
        });

      default:
        return /*#__PURE__*/_jsx(Media, {
          greaterThan: "md",
          className: className,
          style: style,
          children: children
        });
    }
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: calcContentByMode()
  });
};

export default ComponentWrapper;